
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    // Social Icons as SVGs
    const InstagramIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="social-icon"
        >
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
        </svg>
    );

    const FacebookIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="social-icon"
        >
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
        </svg>
    );



    // TikTok Icon (from provided SVG)
    const TikTokIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.89"
            strokeMiterlimit="10"
            className="social-icon"
        >
            <path d="M12.94,1.61V15.78a2.83,2.83,0,0,1-2.83,2.83h0a2.83,2.83,0,0,1-2.83-2.83h0a2.84,2.84,0,0,1,2.83-2.84h0V9.17h0A6.61,6.61,0,0,0,3.5,15.78h0a6.61,6.61,0,0,0,6.61,6.61h0a6.61,6.61,0,0,0,6.61-6.61V9.17l.2.1a8.08,8.08,0,0,0,3.58.84h0V6.33l-.11,0a4.84,4.84,0,0,1-3.67-4.7H12.94Z" />
        </svg>
    );


    const columns = [
        [
            { label: 'Watches', to: '/products?category=watches' },
            { label: 'Help & Services', to: '/services' },
        ],
        [
            { label: 'About Us', to: '/about' },
            { label: 'Careers', to: '/careers' },
            { label: 'Privacy Policy', to: '/privacy-policy' },
        ],
    ];

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-top">
                    <div className="footer-contact">
                        <div className="footer-contact-label">Contact us:</div>
                        <div className="footer-social">
                            <a
                                href="https://www.instagram.com/essentick_official_?igsh=NW16ZTh2dDU4Y295&utm_source=qr"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <InstagramIcon />
                            </a>
                            <a
                                href="https://www.facebook.com/share/1Zvk9WsdhF/?mibextid=wwXIfr"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <FacebookIcon />
                            </a>
                            <a
                                href="https://www.tiktok.com/@essentick.com_official_?_r=1&_t=ZS-93oDiwVnLGv"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="TikTok"
                            >
                                <TikTokIcon />
                            </a>
                        </div>
                    </div>

                    <div className="footer-links-grid">
                        {columns.map((col, colIndex) => (
                            <div key={colIndex} className="footer-column">
                                {col.map((link, linkIndex) => (
                                    <Link key={linkIndex} to={link.to} className="footer-link">
                                        {link.label}
                                    </Link>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="footer-copyright">
                    © {currentYear} Essentick. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
